import { grid, text, vstack } from '@onbeam/business-styled-system/patterns';
import { TargetsSectionItem } from './TargetsSectionItem';
import { targetItems } from './TargetsSection.data';
import { TargetsSectionProps } from './TargetsSection.types';
import { cx } from '@onbeam/business-styled-system/css';

export const TargetsSection = ({
  className,
  ...props
}: TargetsSectionProps) => (
  <section
    className={cx(
      vstack({
        gap: '5',
        textAlign: 'center',
        align: 'center',
      }),
      className,
    )}
    {...props}
  >
    <span
      className={text({
        color: 'mono.tertiary',
        style: { base: 'body-lg', md: 'body-xl' },
      })}
    >
      Who we’re looking for
    </span>
    <h2
      className={text({
        style: 'subtitle-lg',
        maxW: '[62.5rem]',
        md: { textStyle: 'subtitle-xl' },
      })}
    >
      Developers, researchers, and builders across different domains to advance
      Beam.
    </h2>
    <div
      className={grid({
        columns: {
          base: 1,
          sm: 2,
          lg: 4,
        },
        alignItems: 'center',
        justifyContent: 'center',
        w: 'full',
        columnGap: '6',
        rowGap: '10',
        borderY: '1px solid',
        borderColor: 'opacity.sm',
        py: '10',
        mt: '1',
        mdDown: {
          borderX: '1px solid',
          rounded: 'md',
          borderColor: 'opacity.sm',
        },
      })}
    >
      {targetItems.map((item) => (
        <TargetsSectionItem key={item.title} {...item} />
      ))}
    </div>
  </section>
);
